<div
  class="d-flex flex-wrap gap-2 justify-content-between align-items-center mb-4"
>
  <h3 class="m-0">{{ 'pages.cybersocxdr.menu.4A3W' | translate }}</h3>
  <a class="link-chevron" routerLink="/xtended-soc/4A3W">{{
    'pages.cybersocxdr.menu.view4A3W' | translate
  }}</a>
</div>
<div class="row">
  <app-treemap [data]="actions"></app-treemap>
</div>
